import { takeLatest, call, put } from 'redux-saga/effects';
import empSearchApi from 'api/employee/empSearchApi';
import empSearchNoSessionApi from 'api/employee/empSearchNoSessionApi';
import * as userInfoActions from 'redux/ducks/userInfo/userInfoDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getUserInfo() {
  try {
    const userInfo = yield call(empSearchApi.getUserInfo);
    yield put(userInfoActions.getUserInfoSuccess(userInfo));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getRoles() {
  try {
    const roles = yield call(empSearchApi.hasRoles);
    yield put(userInfoActions.getRolesSuccess(roles));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getDisasterRecoveryMode() {
  try {
    const disasterMode = yield call(empSearchApi.getDisasterRecoveryMode);
    yield put(userInfoActions.getDisasterRecoveryModeSuccess(disasterMode.value));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getNoSessionDisasterRecoveryMode() {
  try {
    const disasterMode = yield call(empSearchNoSessionApi.getNoSessionDisasterRecoveryMode);
    yield put(userInfoActions.getNoSessionDisasterRecoveryModeSuccess(disasterMode.value));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* userInfoSaga() {
  yield takeLatest(userInfoActions.getUserInfo, getUserInfo);
  yield takeLatest(userInfoActions.getRoles, getRoles);
  yield takeLatest(userInfoActions.getDisasterRecoveryMode, getDisasterRecoveryMode);
  yield takeLatest(userInfoActions.getNoSessionDisasterRecoveryMode, getNoSessionDisasterRecoveryMode);
}
